<template>
  <div class="imageUpload" @click.stop="$refs.fileInput.click()">
    <div :style="style" class="img">
      <input ref="fileInput" style="display:none" type="file" @change="onFileChanged" />
      <v-icon v-if="!loading" x-large color="primary">mdi-upload</v-icon>
      <v-progress-linear v-if="loading" v-model="percent" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      percent: 0,
      loading: false
    };
  },
  computed: {
    style: function() {
      if (this.model) {
        return {
          backgroundImage:
            "url('" + this.$assets.url(this.model.thumbnailUrl) + "')"
        };
      } else {
        return {};
      }
    },
    model: {
      get: function() {
        return this.value;
      },
      set: function(newVal) {
        this.$emit("input", newVal);
      }
    }
  },
  methods: {
    onFileChanged(event) {
      const file = event.target.files[0];
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file, file.name);
      axios
        .post("upload", formData, {
          onUploadProgress: progressEvent => {
            this.percent = (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then(({ data }) => {
          this.percent = 0;
          this.model = data;
          this.$emit("uploaded");
          this.loading = false;
        })
        .catch(({ response }) => {
          console.log(response.data.errors);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.imageUpload {
  height: 150px;
  width: 150px;
  background-color: #efefef;
  cursor: pointer;
  position: relative;
  .img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
  }
}
</style>
